<template>
  <v-container>
    <h4 v-if="!authenticated">
      You are not logged in! Please
      <a @click="auth.login()">Log In</a> to continue.
    </h4>
    <v-container v-if="authenticated && !hasPermission">
      <p>You do not have access to this area. Please contact Cody at D&S for access.</p>
    </v-container>
    <v-expansion-panel v-if="authenticated && hasPermission">
      <v-expansion-panel-content v-for="(post,i) of posts" :key="i">
        <div slot="header">{{post.subject}}</div>
        <v-card>
          <v-card-text class="grey darken-2">
            <pre>{{post.body}}</pre>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <div id="amzn-assoc-ad-885498b2-2fe5-4529-ab43-aeb6e2d74e63"></div>
    <script2 async src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=885498b2-2fe5-4529-ab43-aeb6e2d74e63"></script2>
  </v-container>
</template>

<script>
export default {
  name: 'LatestPosts',
  props: ['auth', 'authenticated'],
  data() {
    return {
      error: []
    };
  },
  computed: {
    posts() {
      //console.log(this.$store.getters.resentPosts);

      return this.$store.getters.resentPosts;
    },
    hasPermission() {
      return (
        this.$store.getters.roles.indexOf('GlobalAdmin') > -1 ||
        this.$store.getters.roles.indexOf('DSCarwash') > -1
      );
    }
  },
  created() {
    this.$store.dispatch('getResentPosts');
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/LatestPosts.vue